import * as React from 'react';

import { UserService } from '@fnv-core/authentication';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { connect } from 'react-redux';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { LabelAndPopover } from './components/label-and-popover';
import { getResourceString } from '../kentico/resource-strings';
import { getOptionTemplate } from './templates/picklist-templates';

import { FormFieldStateHelpers } from './helpers/FormFieldStateHelpers';
import { AjaxCallHelpers } from './helpers/AjaxCallHelpers';
import { FormikHelpers } from './helpers/FormikHelpers';

import Downshift from 'downshift';

export interface DropdownProps extends FormControlProps {
    forms: any;
}

interface IOption {
  value: any;
  label: string;
}
// dropdown has shouldComponentUpdate .. so if properties are added, also change shouldComponentUpdate event
export interface DropdownState {
    timer: any;
    dataSourceCounter: number;
    value : string;
    hasFocus: boolean;
    isFiltering : boolean;
    isLoading : boolean;   
}    

const mapStateToProps = (state: any) => {
    return {
        forms: state.forms
    };
};

const styles = {
    clearIndicator: () => undefined,
    container: () => undefined,
    control: () => undefined,
    dropdownIndicator: () => undefined,
    groupHeading: () => undefined,
    indicatorsContainer: () => undefined,
    indicatorSeparator: () => undefined,
    input: () => undefined,
    loadingIndicator: () => undefined,
    loadingMessage: () => undefined,
    menu: () => undefined,
    menuList: () => undefined,
    multiValue: () => undefined,
    multiValueLabel: () => undefined,
    multiValueRemove: () => undefined,
    noOptionsMessage: () => undefined,
    option: () => undefined,
    placeholder: () => undefined,
    singleValue: () => undefined,
    valueContainer: () => undefined
};

/**
 * NOTE: When adding new features in this component, please consider to pull out all the rendering to presentational/controls/Dropdown
 * The DropdownMultiple is already there, and should together with this one split out the rendering of a single dropdown component.
 */
class ContainedDropdown extends React.Component<DropdownProps, DropdownState> {
    private selectRef : any = undefined;

    constructor(props: DropdownProps) {
        super(props); 
        this.selectRef = React.createRef();
        if (this.props.formFieldDefinition.datasource) {
            this.state = {                
                dataSourceCounter: 0,
                timer: undefined,                
                [this.props.formFieldDefinition.datasource] : [],
                value: (this.props.field.value && this.props.field.value.value) || (this.props.field.value),
                hasFocus: false,
                isFiltering: false,
                isLoading: false
            };
        } else {
            this.state = {                
                dataSourceCounter: 0,
                timer: undefined,
                value : (this.props.field.value && this.props.field.value.value) || (this.props.field.value),
                hasFocus: false,
                isFiltering: false,
                isLoading: false
            };
        }
    }    

    updateFieldValue = () => {
        let options = ComponentStoreHelpers.getListData(this);
        const dropdownProperties = {
            ...FormControlHelpers.inputProperties(this)
        };
        let selectedOption = options.filter((item) => {
            let valueToCompare = dropdownProperties.value;
            if ((dropdownProperties.value as any).value) {
                valueToCompare = (dropdownProperties.value as any).value;
            }            
            return item.value == valueToCompare;
        });

        if (!!this.props.formFieldDefinition.autoSetUsingDatasource && 
            !!this.props.formFieldDefinition.resetSelectedValueAfterInit &&
            options.length > 0) {

            let data = {};    
            Object.keys(options[0].data).map((optionKey) => {
                data[optionKey] = "";
            });
            this.props.formController.setPayload(data);                
        } else
        if (!!this.props.formFieldDefinition.autoSetUsingDatasource && 
            (!dropdownProperties.value) && 
            options.length > 0) {
            dropdownProperties.value = options[0].value;
            selectedOption = [options[0]];
            if (options[0] && options[0].data) {          
                this.props.formController.setPayload(options[0].data);
            }
        }

        if (selectedOption && selectedOption.length == 0) {
         
            if (this.props.formFieldDefinition.fieldToUseForPreSelect && options.length > 0) {
                const value = this.props.formikBag.values[this.props.formFieldDefinition.fieldToUseForPreSelect];
                if (value && value.value) {
                    selectedOption = options.filter((item) => {
                        let valueToCompare = value;
                        if ((value as any).parent) {
                            valueToCompare = (value as any).parent;
                        } else
                        if ((value as any).value) {
                            valueToCompare = (value as any).value;
                        }
                        return item.value == valueToCompare;
                    });

                    if (selectedOption && selectedOption.length > 0) {
                        dropdownProperties.value = value.value;
                    }
                }
            } else if (options.length == 1 && this.props.formFieldDefinition.isDependentField) {
                selectedOption = options;
                dropdownProperties.value = options[0].value;
            }
        }

        if (selectedOption && selectedOption.length > 0) {
            
            // needed to force initial value in correct format so that if dropdown is not changed by the user
            // that it is correctly shown in the summary
            // see also FormContainer refreshId
            if (!!this.props.formFieldDefinition.resetSelectedValueAfterInit) {
                this.setState({value : undefined}, () => {
                    this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, "");
                    this.props.formikBag.setFieldError(this.props.formFieldDefinition.name, '');
                });
            } else {
                let value = dropdownProperties.value;
                if ((dropdownProperties.value as any).value) {
                    value = (dropdownProperties.value as any).value;
                }                

                this.setState({value : value}, () => {
                    this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, {
                        label: selectedOption[0].label,
                        text: selectedOption[0].label,
                        value: value
                    });
                    this.props.formikBag.setFieldError(this.props.formFieldDefinition.name, '');
                });
            }
        } else {
                         
            this.setState({value : ""} , () => {
                this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, "");
            });
        }
    }

    componentDidMount() {
        this.initDropdown();
    }

    initDropdown = () => {
        if (ComponentStoreHelpers.hasDatasource(this))  {
            this.setState({
              isLoading: true,
          });           
          ComponentStoreHelpers.getData(this).then((result) => {
              if (this.unmounted) {
                  return;
              }
              
              if(result)
              {
                this.setFieldValue(this.props.field.value);
              }
          });
        } else {
            this.updateFieldValue();
        }
    }

    unmounted : boolean = false;

    componentWillUnmount() {
        this.unmounted = true;
    }

    

    private setFieldValue(value) {
      let selectedValues: string = value;

      const options = ComponentStoreHelpers.getListData(this);
      let foundOptions = options.find(opt => opt.value === value);
      if(foundOptions !== undefined
        && foundOptions) {
        // needed to force initial value in correct format so that if dropdown is not changed by the user
        // that it is correctly shown in the summary
        // see also FormContainer refreshId
        this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, foundOptions);
      }
      
      this.setState({
        value: selectedValues,
        isLoading: false,
      });
    }

    componentDidUpdate(prevProps: any) {
        /*
            check here component needs to call ComponentStoreHelpers.getData and reinit component
            depending if form values changed that are listed in dependentOnField array/string
            (check prevProps.formikBag.values vs props.formikBag.values)
        */

        let triggerGetDatasource = false;
        if (Array.isArray(this.props.formFieldDefinition.dependentOnField)) {
            this.props.formFieldDefinition.dependentOnField.map(dependentField => {
                let dependentValue = this.props.formikBag.values[dependentField];
                if (dependentValue && (dependentValue as any).value) {
                    dependentValue = (dependentValue as any).value;
                }

                if (prevProps && prevProps.formikBag && prevProps.formikBag.values) {
                    let prevDependentValue = prevProps.formikBag.values[dependentField];
                    if (prevDependentValue && (prevDependentValue as any).value) {
                        prevDependentValue = (prevDependentValue as any).value;
                    }

                    if (dependentValue != prevDependentValue) {
                        triggerGetDatasource = true;
                    }
                } else {
                    triggerGetDatasource = true;
                }
            });

            if (triggerGetDatasource) {
                this.initDropdown();
            }
        }
    }

    shouldComponentUpdate(nextProps : DropdownProps, nextState : DropdownState) : boolean {
        /*
            check here component needs to update component
            depending if form values changed that are listed in dependentOnField array/string
            (check nextProps.formikBag.values vs props.formikBag.values)
        */
        let triggerGetDatasource = false;
        if (Array.isArray(this.props.formFieldDefinition.dependentOnField)) {
            this.props.formFieldDefinition.dependentOnField.map(dependentField => {

                if (nextProps && nextProps.formikBag && nextProps.formikBag.values) {
                    let dependentValue = nextProps.formikBag.values[dependentField];
                    if (dependentValue && (dependentValue as any).value) {
                        dependentValue = (dependentValue as any).value;
                    }

                    if (this.props && this.props.formikBag && this.props.formikBag.values) {
                        let prevDependentValue = this.props.formikBag.values[dependentField];
                        if (prevDependentValue && (prevDependentValue as any).value) {
                            prevDependentValue = (prevDependentValue as any).value;
                        }

                        if (dependentValue != prevDependentValue) {
                            triggerGetDatasource = true;
                        }
                    } else {
                        triggerGetDatasource = true;
                    }
                } else {
                    triggerGetDatasource = true;
                }
                
            });
        }

        let datasourceDiffers = false;
        if (this.props.formFieldDefinition.datasource) {
            datasourceDiffers = this.state[this.props.formFieldDefinition.datasource] != nextState[this.props.formFieldDefinition.datasource];
        }

        let currentError = "";
        if (this.props.form && this.props.form.errors &&
            this.props.form.errors[this.props.formFieldDefinition.name]) {
            currentError = this.props.form.errors[this.props.formFieldDefinition.name];
        }
        let nextError = "";
        if (nextProps.form && nextProps.form.errors && 
            nextProps.form.errors[nextProps.formFieldDefinition.name]) {
            nextError = nextProps.form.errors[nextProps.formFieldDefinition.name];
        }
        
        let result = datasourceDiffers ||
            (this.props.form && JSON.stringify(this.props.form.values) != JSON.stringify(nextProps.form.values)) ||
            this.state.value != nextState.value ||
            this.state.isFiltering != nextState.isFiltering ||
            this.state.isLoading != nextState.isLoading ||
            this.state.dataSourceCounter != nextState.dataSourceCounter ||
            this.state.hasFocus != nextState.hasFocus ||
            triggerGetDatasource || (nextProps.field.value != this.props.field.value) ||
            (currentError != nextError) ||
            (nextProps.form && nextProps.form.errors && 
                this.props.form && this.props.form.errors && 
                nextProps.form.errors[nextProps.formFieldDefinition.name] != this.props.form.errors[this.props.formFieldDefinition.name]) ||      
            (nextProps.formikBag.values[this.props.formFieldDefinition.name] != this.props.formikBag.values[this.props.formFieldDefinition.name]);
        return result;
    }

    asyncSelectOptions(inputValue) { 
        ComponentStoreHelpers.getAsyncData(inputValue, this);
    }
    
    onClickWrapperDiv(event) {
        // fix because of bug in react-select in combination with openMenuOnClick={false}
        // https://github.com/JedWatson/react-select/issues/3923
        if (!!this.props.formFieldDefinition.onClickFocusHack &&            
            this.selectRef && this.selectRef.current && this.selectRef.current.select?.select) {
            // AsyncSelectable    
            let input =  this.selectRef.current.select.select.inputRef;
            if (!input && this.selectRef.current.select?.select?.select) {
                // AsyncCreatable
                input =  this.selectRef.current.select.select.select.inputRef;
            }
            if (input) {
                input.style.opacity = 1;
                input.focus();
            }
            // cursor is at the beginning of text, but al known ways todo this via code, doesn't work here
        }
    }

    onInputFocus = (event) => {
        this.setState({hasFocus : true});
      }
    
    onInputBlur = (event) => {
        if (event.persist) {
            event.persist();
        }
        this.setState({hasFocus : false}, () => {
            event.target = this;
            this.props.field.onBlur(event);
        });
    }

    hasAsyncData = () => {
        return this.props.formFieldDefinition.datasource && ( 
            this.props.formFieldDefinition.PicklistMode === "picklist" ||
            this.props.formFieldDefinition.PicklistMode === "custompicklist");
    }

    onChange = (value) => {
        let props = this.props;                        
        let newValue = value;
        if (value && value.value) {
            if (value.text) {
                newValue.label = value.text;
            }
        } 
        this.setState({
            isLoading: false,
            isFiltering: this.props.field.value && newValue.label !== this.props.field.value.label, 
            value : ""} , () => {

            if (value && value.data) {     
                props.formController.setPayload(value.data);
            }

            // set parent value if there is one
            if (value && value.parent !== "") {
                const parentValue = props.formikBag.values[props.formFieldDefinition.dependentOnField];

                if (parentValue?.value?.toLowerCase() !== value.parent?.toLowerCase()) {
                    props.formikBag.setFieldValue(props.formFieldDefinition.dependentOnField, value.parent, true);
                }
            }
            // reset child value
            else if (value && props.formFieldDefinition.dependentOnField) {
                props.formikBag.setFieldValue(props.formFieldDefinition.dependentOnField, "", true);
            }

            if (props.formFieldDefinition.isDependentField) {                    
                props.formController.setState({[props.formFieldDefinition.name]: newValue});
            }
            FormFieldStateHelpers.clearMarkedFields(this);
            // Update formik field
            props.formikBag.setFieldTouched(props.formFieldDefinition.name, true, false);
            // By using .then, we have no need for a setTimeout before validating the value.
            props.formikBag.setFieldValue(props.formFieldDefinition.name, {...newValue}, true).then((res) => {
                if ((newValue && newValue.value && newValue.value != "") || 
                    (newValue && newValue.value === undefined && newValue != "")) {
                    props.formikBag.setFieldError(props.formFieldDefinition.name, "");        
                }

                FormControlHelpers.handleTriggerFieldDependingOnCondition(this, newValue);
                if (!!props.formFieldDefinition.mapPayloadFieldsOnChange) {
                    FormikHelpers.mapValuesToFields(this, value.data);  
                }    
                if (props.formFieldDefinition.triggerDatasource) {
                    if (FormControlHelpers.isValid(this)) {
                        // Only get data when input is valid
                        AjaxCallHelpers.getRelatedData(this as any, value);
                    }
                }

                this.props.formikBag.validateForm(this.props.formikBag.values);
            });
        }); 
    }

    hasInputValueChanged = (inputValue) => {
        return !this.props.field.value || (this.props.field.value && inputValue !== this.props.field.value.label);
    }

    additionalDropDownCssClass = () => {
        if (this.props.formFieldDefinition.PicklistMode && this.props.formFieldDefinition.PicklistMode !== "dropdown") {
            return "picklist";
        }
        return""; 
    }

    renderSelectItem = (item, index, getItemProps, highlightedIndex, selectedItem) => {
        const Option = getOptionTemplate(this.props.formFieldDefinition);

        if (this.props.formFieldDefinition.PicklistMode === "custompicklist") {
                                                
            return <Option key={item.value + index.toString()}
                data={item}
                {...getItemProps({                                                    
                    index,
                    item                                                    
                })}                                                
                ></Option>;
        }

        return <li
                className="form-dropdown__option"
                {...getItemProps({
                    key: item.value + index.toString(),
                    index,
                    item,
                    style: {
                        backgroundColor:
                        highlightedIndex === index ? 'lightgray' : 'white',
                        fontWeight: selectedItem === item ? 'bold' : 'normal',
                    },
                })}
            >
                {item.label}
            </li>;
    }
    
    render() {

        // Get options from Kentico or external dataset
        let options = ComponentStoreHelpers.getListData(this);
        let optionsCount = options.length;        

        // Add empty first item if required
        if (this.props.formFieldDefinition.includeDefaultEmptyOption) {
            options = [
                {
                    value: '',
                    label: this.props.formFieldDefinition.defaultEmptyOption,
                    text: this.props.formFieldDefinition.defaultEmptyOption,
                    parent: '',
                    data: {}
                },
                ...options
            ];
        }
        let dropdownProperties = {
            ...FormControlHelpers.inputProperties(this),
            // Overrides: change -> check -> load related data flow
            ...FormControlHelpers.onChangeSetValue(this),
            // Dropdown specific
            options: options,
            styles: styles,
            noOptionsMessage() {
                return getResourceString('Form.Dropdown.NoOptions');
            },
            noSelectionLabel: getResourceString("Form.Dropdown.ChooseOption")           
        };
        
        if ((dropdownProperties.value as any).value === undefined && 
            dropdownProperties.value !== "") {
            const selectedOption = options.filter((item) => {
                return item.value == dropdownProperties.value;
            });

            if (selectedOption && selectedOption.length > 0) {
                (dropdownProperties.value as any) = {
                    value: dropdownProperties.value,
                    label: selectedOption[0].label,
                    text: selectedOption[0].text
                };
            }
        }       
        if (!!this.props.formFieldDefinition.hideWhenNoOptions) {
            if (optionsCount == 0) {
                return <></>;
            }                  
        }

        const Option = getOptionTemplate(this.props.formFieldDefinition);

        // use Select component dependent on user-level setting
        // .. for screenreader user : use native select
        // .. for other users : use Downshift 
        return (
            <div id={this.props.formFieldDefinition.name + "-container"}
                onClick={this.onClickWrapperDiv.bind(this)}
                className={'form-group' + this.props.visibilityClass + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + "-dropdown-form-group"}>
                <LabelAndPopover 
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                {UserService.getUseAccessibleDropdown() === true ? <div className="form-dropdown__container">
                    <select className="form-control form-dropdown__native"
                            name={dropdownProperties.name}
                            auto-correct={"off"}                                                               
                            aria-labelledby={this.props.formFieldDefinition.name + "-label"}
                            value={this.state.value}
                            onChange={(event) => {
                                const dropdownOptions = dropdownProperties.options.filter((option) => {
                                    return option.value == event.target.value;
                                });

                                const dropdownOption = dropdownOptions.length > 0 ? dropdownOptions[0] : undefined;
                                let label = (dropdownOption && dropdownOption.label) ? dropdownOption.label : undefined; 
                                event.persist();
                                this.setState({value : event.target.value}, () => {
                                    dropdownProperties.onChange({
                                        value: event.target.value,
                                        label: label 
                                    });
                                });
                            }}
                            onBlur={(e) => {
                                this.props.field.onBlur({
                                    target: {
                                        value: dropdownProperties.value,
                                        name: this.props.formFieldDefinition.name
                                    }
                                });
                            }}
                        >
                            <option value="" disabled>{getResourceString("Form.Dropdown.ChooseOption")}</option>
                            {dropdownProperties.options.map((option, index) => {
                                return <option value={option.value} key={index}>{option.label}</option>;
                            })}
                    </select></div> : <>
                        <Downshift
                            
                            selectedItem={dropdownProperties && dropdownProperties.value}
                            
                            onInputValueChange={(inputValue , stateAndHelpers) => {
                                if (this.hasAsyncData()) {
                                    if (inputValue.length <= 1) {
                                        this.setState({isFiltering : false}, () => {
                                            stateAndHelpers.closeMenu();
                                        });
                                        
                                        return;
                                    }
                                    if (this.hasInputValueChanged(inputValue)) {
                                        this.asyncSelectOptions(inputValue);
                                    }
                                } else {
                                    this.setState({isFiltering : this.hasInputValueChanged(inputValue)});
                                }
                            }}

                            onChange={(value: any) => { 
                                this.onChange(value);    
                            }                           
                        }
                        
                        onSelect={() => {
                            this.setState({isFiltering : false});
                        }}

                        itemToString={item => (item ? (item.label || "") : '')}
                      >
                        {({
                          getInputProps,
                          getItemProps,
                          getLabelProps,
                          getMenuProps,
                          isOpen,
                          inputValue,
                          highlightedIndex,
                          selectedItem,
                          getRootProps,
                          getToggleButtonProps,
                          selectItem                          
                        }) => (
                          <div className={`${FormStylingHelpers.getDropdownStyle(this)} ${this.additionalDropDownCssClass()}`}>
                            <div
                              className="form-dropdown__control"
                              {...getRootProps({} as any, {suppressRefError: true})}
                            >
                                <div className="form-dropdown__value-container">
                                    <input {...getInputProps()}
                                        
                                        placeholder={getResourceString("Form.Dropdown.ChooseOption")}
                                        aria-labelledby={this.props.formFieldDefinition.name + "-label"}
                                        className={`form-dropdown__input form-dropdown__input-downshift ${this.state.isLoading ? "form-dropdown__input--isloading" : ""}`}
                                        onBlur={this.onInputBlur}
                                        onFocus={this.onInputFocus}
                                    />                                    
                                </div>
                                <div className="form-dropdown__indicators" {...getToggleButtonProps()}>
                                    {this.state.isLoading && <span className="form-dropdown__loader spin-animation spinning-icon"></span>}
                                    <div aria-label={'toggle menu'} className="form-dropdown__indicator form-dropdown__dropdown-indicator">
                                    </div>
                                </div>                                
                            </div>
                            
                            <>{isOpen && <div className="form-dropdown__menu">
                                <ul {...getMenuProps()} className="form-dropdown__menu-list form-dropdown__menu-list-downshift">                              
                                    <>{options
                                        .filter(item => !this.state.isFiltering || (!inputValue || (item && (item.label || "").toLowerCase().indexOf(inputValue.toLowerCase()) >= 0)))
                                        .map((item, index) => {
                                            return this.renderSelectItem(item, index, getItemProps, highlightedIndex, selectedItem);
                                        })
                                    }{this.props.formFieldDefinition.PicklistMode === "custompicklist" &&
                                        !!this.props.formFieldDefinition.allowCreateNewOption && 
                                        <Option key={"__isNew__"} data={{__isNew__ : true}} onNewClick={() => {
                                            ComponentStoreHelpers.clearFields(this);
                                            selectItem({
                                                label: inputValue,
                                                value: inputValue,
                                                text: inputValue,
                                                data: {}
                                            });
                                        }}></Option>
                                    }</>
                                </ul>
                            </div>}</>
                          </div>                          
                        )}
                      </Downshift>                        
                    </>}
                {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
            </div>
        );
    }
}

export const Dropdown = connect(mapStateToProps)(ContainedDropdown);